interface CheckboxProps {
  id?: string;
  displayAs?: 'label' | 'div';
  label?: ReactNode;
  checked: boolean;
  disabled?: boolean;
  onChange: (newValue: boolean, event: ChangeEvent<HTMLInputElement>) => void;
  size?: 'small' | 'regular';
  type?: 'attention' | 'subtle';
}

import type { ChangeEvent, FC, PropsWithChildren, ReactNode } from 'react';

import styles from './Checkbox.module.scss';

const Checkbox: FC<PropsWithChildren<CheckboxProps>> = ({
  id,
  displayAs,
  label,
  checked,
  onChange,
  disabled = false,
  size = 'regular',
  type = 'attention',
}) => {
  const ContainerComponent = displayAs || label ? 'label' : 'div';

  return (
    <ContainerComponent
      className={styles['checkbox']}
      data-disabled={disabled}
      data-size={size}
      data-type={type}
      htmlFor={id}
    >
      <span className={styles['checkbox-input']}>
        <input
          id={id}
          type="checkbox"
          checked={checked}
          disabled={disabled}
          data-disabled={disabled}
          onClick={(e) => e.stopPropagation()}
          onChange={(e) => onChange(e.target.checked, e)}
        />
        <span className={styles['checkbox-control']}>
          <svg className={styles['check']} viewBox="0 0 12 10">
            <polyline points="1.5 6 4.5 9 10.5 1"></polyline>
          </svg>
        </span>
      </span>
      {label && <span className={styles['checkbox-label']}>{label}</span>}
    </ContainerComponent>
  );
};

export default Checkbox;
